import { jsx as _jsx } from "react/jsx-runtime";
import { components } from "react-select";
// reference for getting search to work https://codesandbox.io/s/react-select-input-in-menulist-forked-tqhxgt?file=/example.js:3882-3988
const MenuList = (props) => {
    const { selectProps } = props;
    const { id, showSearch, onInputChange, inputValue } = selectProps;
    return (_jsx("div", { id: id !== undefined ? `${id}-listbox` : undefined, children: _jsx(components.MenuList, Object.assign({ className: "text-md font-normal" }, props)) }));
};
export default MenuList;
